import React from "react";
import AboutClasses from "./About.module.css";
import { Fade } from "react-awesome-reveal";
import rentPayments from "../../../images/HomePage_Updated/rent_payments.png";
import travelPackages from "../../../images/HomePage_Updated/travel_packages.png";
import ferry from "../../../images/HomePage_Updated/ferry.png";

function About() {
    const Services = [
        { Label: "Rent Payments", image: rentPayments },
        { Label: "Travel Packages", image: travelPackages },
        { Label: "Ferry", image: ferry },
    ];

    return (
        <div className={AboutClasses["Container"]} id="about">
            {/* <img src={Bg} alt="Bg" /> */}
            <Fade direction="top-right" triggerOnce>
                <h3> Pay bills on Paygen</h3>
            </Fade>

            <div style={{ width: "100%" }} className={AboutClasses["Services"]}>
                <Fade direction="up" cascade duration={500} triggerOnce>
                    {Services.map((item) => (
                        <div
                            className={AboutClasses["Service_Items"]}
                            key={item.Label}>
                            <img src={item.image} alt={item.Label} />
                            <h3>{item.Label}</h3>
                        </div>
                    ))}
                </Fade>
            </div>
        </div>
    );
}

export default About;
